import ButtonWrapper from '../../../components/button/button-wrapper/ButtonWrapper';
import RoundedButtonAction from '../../../components/button/rounded-button-action/RoundedButtonAction';
import RoundedButtonSecondary from '../../../components/button/rounded-button-secondary/RoundedButtonSecondary';
import ScreenReaderOnly from '../../../accessibility/ScreenReaderOnly';
import { useI18nTexts } from '../../i18n/useI18nTexts';
import {
    SHARE_PROJECT_HELP_TEXT_KEY,
    SHARE_PROJECT_TEXT_KEY,
    SUPPORT_PROJECT_TEXT_KEY,
} from '../../i18n/project-i18n-model';

export const StandardSupportButtons = ({
    project,
    navigateToPayment,
    sharePressed,
    wrapperClass = '',
    showShare = true,
    supportButtonText,
}) => {
    const texts = useI18nTexts([SUPPORT_PROJECT_TEXT_KEY, SHARE_PROJECT_TEXT_KEY, SHARE_PROJECT_HELP_TEXT_KEY]);
    return (
        <ButtonWrapper className={wrapperClass}>
            <RoundedButtonAction
                trackingCategory={'support'}
                trackingAction={'open'}
                trackingParameters={{
                    'button-text': supportButtonText || texts[SUPPORT_PROJECT_TEXT_KEY],
                    buttonType: 'main',
                }}
                onClick={navigateToPayment}
            >
                {supportButtonText || texts[SUPPORT_PROJECT_TEXT_KEY]}
            </RoundedButtonAction>

            {project?.profile?.showSharing && showShare && (
                <>
                    <RoundedButtonSecondary
                        onClick={sharePressed}
                        aria-describedby={'share-button-sticky-description'}
                        trackingCategory="share-project-modal"
                        trackingAction="open-modal"
                        trackingParameters={{
                            'button-text': project.profile?.shareButtonText ?? texts[SHARE_PROJECT_TEXT_KEY],
                        }}
                        label={project.title}
                    >
                        {project.profile?.shareButtonText ?? texts[SHARE_PROJECT_TEXT_KEY]}
                    </RoundedButtonSecondary>

                    <ScreenReaderOnly id="share-button-sticky-description">
                        {texts[SHARE_PROJECT_HELP_TEXT_KEY]}
                    </ScreenReaderOnly>
                </>
            )}
        </ButtonWrapper>
    );
};
